import { Injectable } from '@angular/core';
import { HttpSecureClient } from 'path-shared/services/http/httpSecureClient';
import { AuthGuardService } from 'path-shared/services/authentication/auth-guard.service';
import { Observable } from 'rxjs';
import { config } from 'path-shared/configuration/config';
import { api } from 'path-shared/configuration/urls';
import { SeguretatUsuarisFilter } from '../models/seguretat-usuaris-filter';
import { SeguretatUsuarisFilterService } from './seguretat-usuaris-filter.service';
import { SeguretatUsuaris } from '../models/seguretat-usuaris.model';

const defaultSortParam = 'CodUser';
const defaultSortDirection = 'desc';

@Injectable()
export class SeguretatUsuarisService {
  constructor(private http: HttpSecureClient, private authGuard: AuthGuardService) {}

  getSeguretatUsuaris(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetSeguretatUsuari'].replace('{secure_id}', secure_id), null);
    }
  }

  getSegUsuaris(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetSegUsuari'], null);
    }
  }


  setSeguretatUsuaris(seguretatUsuari: SeguretatUsuaris): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.post(config.urls['apiUrl'] + api.endpoints['urlSetSeguretatUsuaris'], seguretatUsuari);
    }
  }

  getSeguretatUsuarisPerfils(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetSeguretatUsuarisPerfils'], null);
    }
  }

  getSeguretatUsuarisGrups(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetSeguretatUsuarisGrups'], null);
    }
  }

  getSeguretatUsuarisAgents(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetSeguretatUsuarisAgents'], null);
    }
  }

  getSeguretatUsuarisInstitucionAsignada(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetSeguretatUsuarisInstitucioAssignada'], null);
    }
  }

  removeSeguretatUsuari(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteSeguretatUsuari'].replace('{secure_id}', secure_id), null);
    }
  }

  removeSeguretatFormsUsuari(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteSeguretatFormsUsuari'].replace('{secure_id}', secure_id), null);
    }
  }

  removeSeguretatGrupUsuari(codiUser: number, secure_id: string): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteSeguretatGrupUsuari'].replace('{codiUser}', codiUser.toString()).replace('{secure_id}', secure_id), null);
    }
  }

  generateExcel(filter: SeguretatUsuarisFilter, sortDir: string, sortField: string): Observable<any> {
    const start = 0;
    const pageSize = 1000;

    sortField = sortField === undefined ? defaultSortParam : sortField;
    sortDir = sortDir === '' ? defaultSortDirection : sortDir;
    const params = new SeguretatUsuarisFilterService().createFilterParams(filter, start, pageSize, sortField, sortDir);

    if (this.authGuard.canActivate()) {
      return this.http.getFile(config.urls['apiUrl'] + api.endpoints['urlSeguretatUsuarisExcel'],  params );
    }
  }

  getLdapConfig(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetldapConfig'], null);
    }
  }
}
